import { startGame } from '@fg/base/main';
import { Scene } from '@fg/base/scene';
import { AlignGrid } from '@fg/base/phaser_utilities/align_grid';
import store from '@fg/base/store';
class GameScene extends Scene {
    update() {
        super.update();
    }

    init() {
        super.init();

        this.mainSound = this.sound.add('mus_basegame', {"loop":true});
        this.mainSound2 = this.sound.add('sfx_forest_ambience', {"loop":true});
        this.mainSound.play();
        this.mainSound2.play();

        store.commit('toggleExplanation', {
            callback: () => {
                this.letInitialize(() => {
                    this.prepareSounds();
                    this.properties();
                    this.positionerContainer = this.add.rexContainerLite();
                    this.createBg();
                    this.createGameItems();
                    this.createYetiIdle();
                    this.createBonusGame();
                    this.createSnow();
                    this.spritesReady = true;
                    this.createFader();
                    this.baseGamePositioner();
                    this.canvasReady();
                });
            }
        });
    }

    afterPurchase() {
        this.openedLuckySymbols = [];
        this.openedYourSymbols = [];
        
        this.groupedOpenedLuckySymbols = {};
        this.groupedOpenedYourSymbols = {};
        this.starsFound = 0;
        this.tileHitRunning = false;
        this.rowsOpened = 0;
        this.openingAll = false;
        this.bonusStarted = false;
        this.bonusActive = false;
        this.bonusFinished = false;
        
        this.afterPurchaseAnimation();

        if(this.request.scenario.bonus !== undefined) {
            this.loadBonus();
        }
        
        this.loadSymbols(() => {
            store.commit('showOpenAllButton');
        });
    }

    beforePurchase() {
        this.hideYetiText(0, false);
    }

    prepareSounds() {
        this.bonusSound = this.sound.add('mus_bonusgame', {"loop":true, "volume": 0});
        this.owlSound = this.sound.add('sfx_owl');
        this.beaterRisingSound = this.sound.add('sfx_beater_rising');
        this.bigWinSound = this.sound.add('stg_popup-big_win');
        this.bonusWinSound = this.sound.add('stg_popup_bonus_win');
        this.regularWinSound = this.sound.add('stg_popup_regular_win');

        this.randomizeOwlSound();
    }

    randomizeOwlSound() {
        this.owlSound.play();
        this.owlTimer = this.time.delayedCall(Phaser.Math.RND.integerInRange(10000, 25000), () => {
            this.randomizeOwlSound();
        });
    }

    openAll(forceOpenRow) {
        if(this.bonusStarted) {
            return;
        }

        if(Config.assets.settings.disable_open_all || forceOpenRow) {
            let symbolOpened = false;
            
            for(let i = 0; i < 4; i++) {
                if(!this.gameItemsRows[i].opened && !this.gameItemsRows[i].opening) {  
                    this.gameItemsRows[i].opening = true;

                    for (let [index, item] of Object.entries(this.gameItemsRows[i].items)) {
                        if(!item.opened) {
                            this.openYourSymbol(item.absoluteIndex, item, true);
                            symbolOpened = true;
                        }
                    }
                }

                if(symbolOpened) {
                    this.sound.play('sfx_reveal_' + Phaser.Math.RND.integerInRange(1, 6), {"volume":0.5});
                    return;
                }
            }
        } else {
            this.openingAll = true;
            this.rowsOpened = 4;

            for(let i = 0; i < 20; i++) {
                const item = this.mainGameItems['your_symbols'][i];
                
                if(!item.opened) {
                    this.openYourSymbol(i, item, true);
                }
            }
            
            this.sound.play('sfx_reveal_' + Phaser.Math.RND.integerInRange(1, 6), {"volume":0.5});
        }
    }

    yetiHitGround(callback) {
        if(this.yetiIdle.anims.currentAnim.key === 'yeti_hit_ground') {
            return;
        }

        this.yetiIdle.play('yeti_hit_ground');
        this.sound.play('sfx_yeti_click-on');
        
        this.time.delayedCall(400, () => {
            this.cameras.main.shake(400, 0.01);
            this.sound.play('sfx_yeti_ground_hit');
        });

        this.yetiIdle.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {

            if(callback) {
                callback();
            }

            this.yetiIdle.play('yeti_idle');
        });
    }

    createYetiIdle() {
        this.yetiIdle = this.add.sprite(0, 0, 'yeti_idle').setOrigin(0.5, 1);

        let config = this.anims.create({
            key: 'yeti_idle',
            frames: this.anims.generateFrameNames('yeti_idle',
            {
                prefix: 'yeti_idle_',
                start: 1,
                end: 170,
                suffix: '.png' 
            }),
            frameRate: 13,
            yoyo: true,
            repeat: -1
        });

        this.yetiIdle.anims.load(config);

        config = this.anims.create({
            key: 'yeti_hit_ground',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('yeti_hit_ground', {
                start: 0,
                end: 16,
            }),
            frameRate: 25
        });
        
        this.yetiIdle.anims.load(config);

        this.yetiIdle.setFrame('yeti_idle_1.png');

        this.yetiIdle.play('yeti_idle');
        
        this.yetiIdleSpeech = this.add.sprite(0, 0, 'speech_bubble').setOrigin(0, 0.5).setAlpha(0);
        
        this.yetiIdleSpeechText = this.add.text(0, 0, '', this.fonts.yeti_speech_text).setOrigin(0.5, 0.5).setAlpha(0);
    }

    showYetiText(text, turnoffAfter, callback) {
        if(Config.assets.settings.show_yeti_text) {
            this.yetiIdleSpeechText.setText(text);
            this.tweens.add({
                targets: [this.yetiIdleSpeech, this.yetiIdleSpeechText],
                alpha: 1,
                ease: 'Power0',
                duration: 500,
                onComplete: () => {
                    this.sound.play('sfx_yeti_click-on');
                    this.hideYetiText(turnoffAfter, callback);
                }
            });
        } else {
            if(callback) {
                callback();
            }
        }
    }

    hideYetiText(turnoffAfter, callback) {
        this.tweens.add({
            targets: [this.yetiIdleSpeech, this.yetiIdleSpeechText],
            alpha: 0,
            ease: 'Power0',
            duration: 500,
            delay:turnoffAfter,
            onComplete: () => {
                this.yetiIdleSpeechText.setText('');

                if(callback) {
                    callback();
                }
            }
        });
    }

    createSnow() {
        let frames = [...Array(6).keys()];

        this.snowParticles1 = this.add.particles('snowflakes');

        this.snow1 = this.snowParticles1.createEmitter({
            frame:  {frames, cycle: true },
            x: { min: 0, max: this.cameras.main.width },
            y: -50,
            lifespan: 12000,
            gravity: 0,
            quantity: 1,
            speedY: {min: 20, max: 100},
            rotate: { start: 0, end: 360 },
            scale: { min: 0.2, max: 1},
            frequency: 200,
            blendMode: 'ADD'
        });

        this.snowParticles2 = this.add.particles('snowflakes');

        this.snow2 = this.snowParticles2.createEmitter({
            frame:  {frames, cycle: true },
            x: { min: 0, max: this.cameras.main.width },
            y: -50,
            lifespan: 12000,
            gravity: 0,
            quantity: 1,
            speedY: 100,
            rotate: { start: 0, end: 120 },
            scale: { min: 0.2, max: 0.5},
            frequency: 200,
            blendMode: 'ADD'
        });

        this.time.addEvent({
            delay: 8000,
            callback: () => {
                let speed = Phaser.Math.RND.integerInRange(-50, 50);

                this.snow1.setSpeedX(speed);
                this.snow2.setSpeedX(speed);
            },
            callbackScope: this,
            loop: true
        });

    }

    loadSymbols(callback) { 
        for(let i = 0; i < 4; i++) {
            this.itemGoDown(this.mainGameItems['lucky_symbols'][i], !(i % 2));

            this.mainGameItems['lucky_symbols'][i].number.setTexture(`counter_${this.request.scenario.lucky_symbols[i]}_blue`)
        }

        for(let i = 0; i < 20; i++) {
            this.itemGoDown(this.mainGameItems['your_symbols'][i], !(i % 3));
            this.mainGameItems['your_symbols'][i].number.setTexture(this.request.scenario.your_symbols[i].symbol == 'star' ? this.request.scenario.your_symbols[i].symbol : `counter_${this.request.scenario.your_symbols[i].symbol}_blue`);
           
            if(this.request.scenario.your_symbols[i].symbol != 'star') {
                let amount = this.request.scenario.your_symbols[i].amount;

                this.mainGameItems['your_symbols'][i].win.setText(General.format_currency(amount, Math.round(amount) == amount));
                this.customHelper.applyDynamicFontSize(this.mainGameItems['your_symbols'][i].win, this.mainGameItems['your_symbols'][i].win_placeholder.displayWidth - 40);
            }
        }

        this.tweens.add({
            targets: this.fullFaderMain,
            alpha: 0,
            ease: 'Power0',
            duration: 500,
        });

        this.time.delayedCall(1000, () => {
            this.sound.play('sfx_reveal_' + Phaser.Math.RND.integerInRange(1, 6), {"volume":0.5});

            for(let i = 0; i < 4; i++) {
                let item = this.mainGameItems['lucky_symbols'][i];
                this.openLuckySymbol(i, item);
            }
    
            for(let i = 0; i < 20; i++) {
                let item = this.mainGameItems['your_symbols'][i];
                item.setInteractive({ cursor: 'pointer', pixelPerfect: true})
                    .on('pointerup', () => {
                        if(this.openingAll) { 
                            return;
                        }

                        this.openYourSymbol(i, item);
                    })
                    .on('pointerover', () => {
                        this.itemHover(item, 0.9);
                        this.sound.play('sfx_hover', {'volume': 0.1});
                        
                    })
                    .on('pointerout', () => {
                        this.itemHover(item, 1);
                    });

                if(i === 19) {
                    callback();
                }    
            }
        });

        this.enableIdleTimer();
    }

    itemHover(item, scale) {
        if(item.hover_tween && item.hover_tween.isPlaying()) {
            item.hover_tween.stop();
        }

        item.hover_tween = this.tweens.add({
            targets: [item],
            scale: scale,
            duration: 50,
            ease: 'Power0'
        });
    }

    loadBonus() {
        this.bonusWinningsContainer = this.add.container();
        this.bonusWinningsContainer.setAlpha(0);
        this.bonusWinningsItems = [];

        let stepY = (this.bonus_pole.displayHeight - 550) / this.request.scenario.bonus.odds.length;
        let currentY = this.bonus_pole.y - stepY - 300;

        let currentOriginX = 1;
        
        for (let [index, odd] of Object.entries(this.request.scenario.bonus.odds)) {
            let letter = currentOriginX ? 'l' : 'r';
            let size = 'small';
            let stringLength = String(odd).trim().length;
            let bonusItemWonSomething = this.request.scenario.bonus && parseInt(index) === parseInt(this.request.scenario.bonus['index']) && this.request.scenario.bonus['value'] > 0;

            if(stringLength > 4) {
                size = 'big';
            } else if(stringLength > 2) {
                size = 'medium';
            }

            let itemItemSideSize = 207;
            let item = this.add.sprite(0, currentY, `${size}_${letter}`).setOrigin(currentOriginX, 0.5);
            let amountOffset = (currentOriginX ? 
                -(item.displayWidth - itemItemSideSize) / 2 - itemItemSideSize + 17.5
                : (item.displayWidth - itemItemSideSize) / 2 + itemItemSideSize - 17.5
            );

            item.amount = this.customHelper.createWinningFromSprites(odd, 1, '_red', -25);

            this.customHelper.applyDynamicSpriteSize(item.amount, item.width - itemItemSideSize - 35);

            item.amount.setX(item.x + amountOffset ).setY(item.y);
            
            if(bonusItemWonSomething) {
                item.win_light = this.add.sprite(item.amount.x, item.amount.y, 'win_light_big').setOrigin(0.5).setAlpha(0).setScale(0);
                this.bonusWinningsContainer.add(item.win_light);
                item.frame_anim = this.add.sprite(item.x + (currentOriginX ? 25 : -25), item.y, `${size}_${letter}_anim`).setOrigin(currentOriginX, 0.5).setAlpha(0);

                item.amount_won = this.customHelper.createWinningFromSprites(odd, 1, '_yellow', -25);
                this.customHelper.applyDynamicSpriteSize(item.amount_won, item.width - itemItemSideSize - 35);
                item.amount_won.setX(item.amount.x).setY(item.amount.y).setAlpha(0);

                let prefix = letter.toUpperCase() + size.charAt(0).toUpperCase();
                let end = 39;

                if(size === 'medium') {
                    end = 33;
                } else if (size === 'small') {
                    end = 30;
                }

                let config = this.anims.create({
                    key: `${size}_${letter}_anim`,
                    frames: this.anims.generateFrameNames(`${size}_${letter}_anim`,
                    {
                        prefix,
                        start: 1,
                        end,
                        suffix: '.png' 
                    }),
                    frameRate: 15,
                    yoyo: true,
                    repeat: -1
                });

                item.frame_anim.anims.load(config);
            }

            this.bonusWinningsContainer.add(item);

            if(bonusItemWonSomething) {
                this.bonusWinningsContainer.add(item.amount_won);
            }
            
            this.bonusWinningsContainer.add(item.amount);
            this.bonusWinningsItems.push(item);
            
            if(bonusItemWonSomething) {
                this.bonusWinningsContainer.add(item.frame_anim);
            }
            
            if(!currentOriginX) {
                currentOriginX = 1;
            } else { 
                currentOriginX = 0;
            }

            currentY -= stepY;
        }
        
        this.bonusWinningsContainer.setX(this.bonusContainer.x).setY(this.bonusContainer.y);
        this.bonusWinningsContainer.setScale(this.bonusContainer.scaleX);
    }

    itemGoDown(item, playSound) {
        item.y = -(item.displayHeight);
        let delay = Phaser.Math.RND.integerInRange(0, 1000);

        item.setAlpha(1);
            
        item.dropTween = this.tweens.add({
            targets: item,
            y: item.originalY,
            duration: item.originalY * .5,
            ease: Phaser.Math.Easing.Sine.In,
            delay,
            onComplete: () => {
                if(playSound) {
                    this.sound.play('sfx_snowballs-drops');
                }
            }
        });
    }

    enableIdleTimer() {
        this.idleTimer = this.time.addEvent({
            delay: 10000,
            callback: this.shakeUnopenedSymbols,
            callbackScope: this,
            loop: true
        });
    }

    resetIdleTimer() {
        this.stopIdleTimer();
        this.enableIdleTimer();
    }

    stopIdleTimer() {
        if(this.idleTimer) {
            this.idleTimer.remove();
        }
    }

    shakeUnopenedSymbols() {
        this.sound.play('sfx_snowballs-inactive', {"volume":0.5});

        for(let i = 0; i < 20; i++) {
            let item = this.mainGameItems['your_symbols'][i];
            
            if(!item.opened) {
                item.shake_tween = this.tweens.add({
                    targets: [item],
                    angle: 720,
                    duration: Phaser.Math.RND.integerInRange(100, 700),
                    ease: 'Power0',
                });
            }
        }
    }

    openLuckySymbol(index, item) {
        if(item.opened) {
            return false;
        }

        this.customHelper.removeClickable(item);
        item.opened = true;

        const luckySymbol = this.request.scenario.lucky_symbols[index];

        this.openedLuckySymbols.push(luckySymbol);
        this.groupedOpenedLuckySymbols[luckySymbol] = item;

        item.exploder.setAlpha(1);
        item.exploder.play('ball_explode');
        item.setAlpha(0);
        
        this.tweens.add({
            targets: [item.number],
            alpha: 1,
            duration: 500,
            ease: 'Power0',
            onComplete: () => {
            }
        });
        
        item.exploder.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            item.exploder.setAlpha(0);
        });

        this.checkForContinueGame();
    }

    openYourSymbol(index, item, openAll) {
        if(item.opened || (this.bonusStarted && !this.openingAll)) {
            return false;
        }

        this.customHelper.removeClickable(item);
        item.opened = true;

        if(item.shake_tween && item.shake_tween.isPlaying()) {
            item.shake_tween.stop();
            item.setAngle(0);
        }
        
        if(item.hover_tween && item.hover_tween.isPlaying()) {
            item.hover_tween.stop();
            item.setScale(1);
        }

        this.gameItemsRows[item.row].symbolsOpened++;

        if(this.gameItemsRows[item.row].symbolsOnRow === this.gameItemsRows[item.row].symbolsOpened) {
            this.gameItemsRows[item.row].opened = true;
            this.rowsOpened++;

            if(this.rowsOpened === Object.keys(this.gameItemsRows).length) {
                store.commit('disableOpenAllButton');
                
                this.customHelper.removeClickable(this.yetiIdle);
            }
        }

        const yourSymbol = this.request.scenario.your_symbols[index].symbol;

        this.openedYourSymbols.push(yourSymbol);

        if(!this.groupedOpenedYourSymbols[yourSymbol]) {
            this.groupedOpenedYourSymbols[yourSymbol] = [];
        }

        this.groupedOpenedYourSymbols[yourSymbol].push(item);

        item.exploder.setAlpha(1);
        item.exploder.play('holder_explode');

        if(! openAll) {
            this.sound.play('sfx_reveal_' + Phaser.Math.RND.integerInRange(1, 6), {"volume":0.5}, {"volume":0.5});
        }

        item.setAlpha(0);
        item.holder.setAlpha(0);

        if(yourSymbol == 'star') {
            item.number.setTexture('star');

            this.tweens.add({
                targets: [item.number],
                alpha: 1,
                duration: 500,
                ease: 'Power0'
            });

            item.exploder.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                this.starsFound++;

                if(this.starsFound === 3) {
                    this.bonusStarted = true;
                }

                this.flyStar(item, this.starsFound);
                item.exploder.setAlpha(0);
            });
            
        } else {
            this.tweens.add({
                targets: [item.number, item.win_placeholder, item.win],
                alpha: 1,
                duration: 500,
                ease: 'Power0'
            });
            item.exploder.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                if(this.request.scenario.your_symbols[index].win 
                        && this.openedLuckySymbols.includes(yourSymbol)
                        && this.request.scenario.lucky_symbols.includes(yourSymbol)
                    ) {
                    this.request.addAmountWon(this.request.scenario.your_symbols[index].amount);
                    item.number.setTexture(`counter_${yourSymbol}_red`);
                    item.win.setStyle(this.fonts.winRed);
                    this.customHelper.applyDynamicFontSize(item.win, item.win_placeholder.displayWidth - 40);
                    item.number.play(`counter_${yourSymbol}_red`);
                    
                    this.sound.play('sfx_numbers_match');
        
                    this.tweens.add({
                        targets: [item.win_light],
                        alpha: 1,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out,
                        onComplete: () => {
                            item.win_light.tween = this.tweens.add({
                                targets: [item.win_light],
                                angle: 360,
                                scale: 0.5,
                                yoyo: true,
                                duration: 10000,
                                repeat: -1,
                                ease: 'Power0'
                            });
                        }
                    });

                    if(this.groupedOpenedLuckySymbols[yourSymbol]) { 
                        this.time.delayedCall(500, () => {
                            this.groupedOpenedLuckySymbols[yourSymbol].number.setTexture(`counter_${yourSymbol}_red`);
                        });
                    }
                } else {
                    item.number.play(`counter_${yourSymbol}_blue`);
                }
                
                item.exploder.setAlpha(0);
            });
        }

        this.checkForContinueGame();
    }

    afterPurchaseAnimation() {
        if(this.request.gamePlayedTimes > 0) {
            this.resetGame();
        } else {
        }
    }

    flyStar(item, starsFound) {
        let star = this.add.sprite(item.number.x, item.number.y, 'star').setOrigin(0.5);

        let toX = this.bonus_marker.x - 335;
        let toY = this.bonus_marker.y - 165;
        let angle = -15;
        
        if(starsFound === 2) {
            angle = 0;
            toX += 115;
            toY -= 30;

        } else if (starsFound === 3) {
            angle = 15;
            toX += 230;
        }
        
        item.number.setTexture('blank_star');

        this.tweens.add({
            targets: star,
            x: toX,
            y: toY,
            scale: 0.1,
            duration: 500,
            ease: 'Power0',
            delay: 0,
            angle,
            onComplete: () => {
                star.destroy();
                this.bonus_marker.play(`bonus_${starsFound}`);
                this.sound.play('sfx_star-impact');
                
                if(starsFound === 3) {
                    this.time.delayedCall(1000, () => {
                        this.continueToBonus();
                    });
                }
            }
        });

    }

    resetGame() {
        this.bonus_button.setTexture('button');
        this.bonus_marker.setTexture('bonus_1').setFrame(0);
        this.bonus_flying_tile.setFrame(0);
        this.positionTile();

        for(let i = 0; i < 4; i++) {
            let item = this.mainGameItems['lucky_symbols'][i];
            item.setAlpha(0);
            item.exploder.setAlpha(0);
            item.number.setAlpha(0);
            item.opened = false;

            this.gameItemsRows[i].opened = false;
            this.gameItemsRows[i].symbolsOpened = 0;
            this.gameItemsRows[i].opening = false;
        }

        for(let i = 0; i < 20; i++) {
            let item = this.mainGameItems['your_symbols'][i];
            item.setAlpha(0);
            item.win_light.setAlpha(0);
            item.number.setAlpha(0);
            item.win_placeholder.setAlpha(0);
            item.win.setStyle(this.fonts.winBlue);
            item.win.setAlpha(0).setText(0);
            item.exploder.setAlpha(0);
            item.holder.setAlpha(1);
            item.opened = false;

            if(item.win_light.tween && item.win_light.tween.isPlaying()) {
                item.win_light.tween.stop();
                item.win_light.setAngle(0);
                item.win_light.setScale(1);
            }
        }
    }

    ticketFinished() {
        store.commit('hideOpenAllButton');
        this.request.ticketFinished();
    }

    afterComplete() {
    }

    createBg() {
        this.bg = this.add.sprite(0, 0, 'bg').setOrigin(0.5, 0);
        this.positionerContainer.add(this.bg);
        this.shadow = this.add.sprite(0, 0, 'symbols_shadow').setOrigin(0.5, 0.5);
        
        this.tree_left = this.add.sprite(0, 0, 'tree_left').setOrigin(0.5, 1).setAngle(-2);
        this.tree_right = this.add.sprite(0, 0, 'tree_right').setOrigin(0.5, 1).setAngle(1);
        this.bonus_marker = this.add.sprite(0, 0, 'bonus_1').setOrigin(1, 1).setFrame(0);
        this.bonusText = this.add.sprite(0, 0, 'bonus_text');
        this.logo = this.add.sprite(0, 0, 'logo').setOrigin(0, 0);

        this.tree_left.tween = this.tweens.add({
            targets: this.tree_left,
            angle: 2,
            ease: 'Power0',
            duration: 10000,
            yoyo: true,
            repeat: -1
        });

        this.tree_right.tween = this.tweens.add({
            targets: this.tree_right,
            angle: -1,
            ease: 'Power0',
            duration: 9000,
            yoyo: true,
            repeat: -1
        });

        let config = false;

        for(let i = 1; i <= 3; i++) {
            config = {
                key: `bonus_${i}`,
                skipMissedFrames: true,
                frames: this.anims.generateFrameNumbers(`bonus_${i}`, {
                    start: 0,
                    end: 18,
                }),
                frameRate: 25
            };

            this.bonus_marker.anims.create(config);
        }
    }

    createGameItems() {
        this.mainGameGroup = this.add.rexContainerLite();
        this.mainGameItems = {'lucky_symbols':{}, 'your_symbols':{}};
        this.luckyNumberRibbon = this.add.sprite(0, 0, 'ribbons').setOrigin(0.5, 0.5);
        this.luckyNumberRibbonText = this.add.text(0, 0, Config.lang.lucky_numbers, this.fonts.normalWhite).setOrigin(0.5, 0.5);
        this.customHelper.applyDynamicFontSize(this.luckyNumberRibbonText, this.luckyNumberRibbon.displayWidth - 200);
        this.yourNumberRibbon = this.add.sprite(0, 0, 'ribbons').setOrigin(0.5, 0.5);
        this.yourNumberRibbonText = this.add.text(0, 0, Config.lang.your_numbers, this.fonts.normalWhite).setOrigin(0.5, 0.5);
        this.customHelper.applyDynamicFontSize(this.yourNumberRibbonText, this.yourNumberRibbon.displayWidth - 200);

        this.mainGameGroup.add(this.luckyNumberRibbon);
        this.mainGameGroup.add(this.luckyNumberRibbonText);
        this.mainGameGroup.add(this.yourNumberRibbon);
        this.mainGameGroup.add(this.yourNumberRibbonText);
        
        let config = {
            key: 'holder_explode',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('holder_explode', {
                start: 0,
                end: 12,
            }),
            frameRate: 25,
        };

        this.anims.create(config);

        config = {
            key: 'ball_explode',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('ball_explode', {
                start: 0,
                end: 12,
            }),
            frameRate: 25,
        };

        this.anims.create(config);

        for(let i = 0; i <= 9; i++) {
            for (let color of ['red', 'blue', 'yellow']) {
                config = {
                    key: `counter_${i}_${color}`,
                    skipMissedFrames: true,
                    frames: this.anims.generateFrameNumbers(`counter_${i}_${color}`, {
                        start: 0,
                        end: 7,
                    }),
                    frameRate: 25,
                    yoyo: true
                };
                this.anims.create(config);
            }
        }

        for(let i = 0; i < 4; i++) {
            let item = this.add.sprite(0, 0, 'snowball').setOrigin(0.5).setAlpha(0);
            item.exploder = this.add.sprite(0, 0, 'ball_explode').setOrigin(0.5).setAlpha(0);
            item.number = this.add.sprite(0, 0, 'blue_0').setOrigin(0.5).setAlpha(0);
            
            this.mainGameGroup.add(item.number);
            this.mainGameGroup.add(item);
            this.mainGameGroup.add(item.exploder);
            this.children.bringToTop(item);
            this.mainGameItems['lucky_symbols'][i] = item;
        }

        this.luckyNumbersHolder = this.add.sprite(0, 0, 'lucky_numbers').setOrigin(0.5, 0.5);
        this.mainGameGroup.add(this.luckyNumbersHolder);

        this.gameItemsRows = [];

        let rowIndex = 0;

        for(let i = 0; i < 20; i++) {
            let item = this.add.sprite(0, 0, 'snowball').setOrigin(0.5).setAlpha(0);
            item.indexOnGame = i;
            item.win_light = this.add.sprite(0, 0, 'win_light').setOrigin(0.5).setAlpha(0);
            item.number = this.add.sprite(0, 0, 'blue_0').setOrigin(0.5).setAlpha(0);
            item.win_placeholder = this.add.sprite(0, 0, 'win_placeholder').setOrigin(0.5).setAlpha(0);
            item.win = this.add.text(0, 0, '0', this.fonts.winBlue).setOrigin(0.5).setAlpha(0);

            item.exploder = this.add.sprite(0, 0, 'holder_explode').setOrigin(0.5).setAlpha(0);
            item.holder = this.add.sprite(0, 0, 'snowball_holder').setOrigin(0.5, 0);
            item.absoluteIndex = i;

            if(!this.gameItemsRows[rowIndex]) {
                this.gameItemsRows[rowIndex] = [];
                this.gameItemsRows[rowIndex].opened = false;
                this.gameItemsRows[rowIndex].opening = false;
                this.gameItemsRows[rowIndex].symbolsOnRow = 0;
                this.gameItemsRows[rowIndex].symbolsOpened = 0;
                this.gameItemsRows[rowIndex].items = [];
            }

            item.row = rowIndex;
            this.gameItemsRows[rowIndex].symbolsOnRow++;
            this.gameItemsRows[rowIndex].items.push(item);

            if([4, 10, 15].includes(i)) {
                rowIndex++;
            }

            this.mainGameGroup.add(item.win_light);
            this.mainGameGroup.add(item.number);
            this.mainGameGroup.add(item.win_placeholder);
            this.mainGameGroup.add(item.win);
            this.mainGameGroup.add(item);
            this.mainGameGroup.add(item.holder);
            this.mainGameGroup.add(item.exploder);
            this.children.bringToTop(item);
            this.children.bringToTop(item.exploder);
            this.children.bringToTop(item.holder);
            this.mainGameItems['your_symbols'][i] = item;
        }
    }

    checkForContinueGame() {
        store.commit('hideCustomPlayButton');

        if(this.openedLuckySymbols.length === 4 && this.openedYourSymbols.length === 20) {
            if(this.request.scenario.bonus === undefined || this.bonusFinished) {
                this.time.delayedCall(1000, () => {
                    this.finishGame();
                });

                this.stopIdleTimer();
            }
        } else {
            store.commit('showOpenAllButton');

            this.resetIdleTimer();
        }
    }

    finishGame() {
        this.fadeOutUnluckyItems();

        if(this.request.scenario.total_prize > 0) {
            const ratio = this.request.scenario.total_prize / this.request.ticketAmount;

            if(ratio >= Config.assets.ratios.big_win) {
                this.showBigWin();
            } else {
                this.showRegularWin();
            }
        } else {
            this.ticketFinished();
            this.showYetiText(Config.language == 'lt' ? Config.lang.try_again : Config.lang.noWinning, 3000, () => {
                if(!this.request.ticketInProgress) {
                    this.fadeInMainFader();
                }
            });
        }
    }

    fadeOutUnluckyItems() {
        for(let i = 0; i < 20; i++) {
            if(!this.request.scenario.your_symbols[i].win) {
                let item = this.mainGameItems['your_symbols'][i];
                
                this.tweens.add({
                    targets: this.request.scenario.your_symbols[i].symbol != 'star' ? [item.number, item.win_placeholder, item.win] : item.number,
                    alpha: 0.65,
                    ease: 'Power0',
                    duration: 200,
                });
            }
        }
    }

    showRegularWin() {
        this.regularWinDestroyed = false;
        this.regularWinContainer = this.add.container();
        this.regularWinContainer.setAlpha(0);

        this.popBg = this.add.sprite(0, 0, 'pop_bg').setOrigin(0.5);
        this.popLights = this.add.sprite(0, 0, 'pop_lights').setOrigin(0.5);

        this.regularWinTitle = this.add.text(0, 0, Config.lang.winning, this.fonts.white_title).setOrigin(0.5, 1).setScale(0);
        this.regularWinAmountContainer = this.customHelper.createWinningFromSprites(General.format_currency(this.request.scenario.total_prize).replace(Config.currency.symbol, ''), 1, '_blue', -25);
        this.regularWinContainer.add(this.popBg);
        this.regularWinContainer.add(this.popLights);
        this.regularWinContainer.add(this.regularWinTitle);
        this.regularWinContainer.add(this.regularWinAmountContainer);

        this.regularWinPositioner();
        this.regularWinTitle.setScale(0);
        this.regularWinAmountContainer.setScale(0);
        
        this.tweens.add({
            targets: this.regularWinContainer,
            alpha: 1,
            ease: 'Power0',
            duration: 500,
            onComplete: () => {
                this.regularWinSound.play();

                this.regularWinTween = this.tweens.add({
                    targets: [this.regularWinTitle, this.regularWinAmountContainer],
                    scale: 1,
                    ease: Phaser.Math.Easing.Back.Out,
                    duration: 500,
                    onComplete: () => {
                        this.regularWinContainer.setInteractive({ cursor: 'pointer'})
                        .once('pointerup', () => {
                            this.destroyRegularWin();
                        });

                        this.regularWinTimer = this.time.delayedCall(3000, () => {
                            this.destroyRegularWin();
                        })
                    }
                });
            }
        });
    }

    destroyRegularWin() {
        if (this.regularWinDestroyed) {
            return;
        }

        this.regularWinDestroyed = true;
        
        this.customHelper.removeClickable(this.regularWinContainer);

        if(this.regularWinTimer) {
            this.regularWinTimer.remove();
        }
        this.tweens.add({
            targets: this.regularWinContainer,
            alpha: 0,
            ease: 'Power0',
            duration: 500,
            onComplete: () => {
                if(this.regularWinTween && this.regularWinTween.isPlaying()) {
                    this.regularWinTween.stop();
                    this.regularWinTween.remove();
                }
                
                if(this.regularWinContainer) {
                    this.regularWinContainer.destroy();
                }

                if(this.regularWinAmountContainer) {
                    this.regularWinAmountContainer.destroy();
                }

                this.ticketFinished();
                this.fadeInMainFader();
                
                this.regularWinSound.stop();
            }
        });
    }

    showBigWin() {
        this.bigWinDestroyed = false;
        this.bigWinContainer = this.add.container();
        this.bigWinContainer.setAlpha(0);

        this.popBg = this.add.sprite(0, 0, 'pop_bg').setOrigin(0.5);
        this.popLights = this.add.sprite(0, 0, 'pop_lights').setOrigin(0.5);
        this.winLightBig = this.add.sprite(0, 0, 'win_light_big').setOrigin(0.5);

        this.bigWinTitle = this.add.text(0, 0, Config.lang.big, this.fonts.white_title).setOrigin(0.5, 1).setScale(0);
        this.bigWinTitle2 = this.add.text(0, 0, Config.lang.winning, this.fonts.white_title_big).setOrigin(0.5, 1).setScale(0);
        this.bigWinAmountContainer = this.customHelper.createWinningFromSprites(General.format_currency(this.request.scenario.total_prize).replace(Config.currency.symbol, ''), 1, '_red', -25);

        this.yetiDown = this.add.sprite(0, 0, 'yeti_down').setOrigin(0.5, 0);

        let config = this.anims.create({
            key: 'yeti_down',
            frames: this.anims.generateFrameNames('yeti_down',
            {
                start: 1,
                end: 6,
                suffix: '.png' 
            }),
            frameRate: 15
        });

        this.yetiDown.anims.load(config);
        this.yetiDown.setFrame('1.png');

        this.bigWinContainer.add(this.popBg);
        this.bigWinContainer.add(this.popLights);
        this.bigWinContainer.add(this.winLightBig);
        this.bigWinContainer.add(this.yetiDown);
        this.bigWinContainer.add(this.bigWinTitle);
        this.bigWinContainer.add(this.bigWinTitle2);
        this.bigWinContainer.add(this.bigWinAmountContainer);

        this.bigWinParticles = this.add.particles('confetti');

        let frames = [];

        for(let i = 1; i < 142; i++) {
            frames.push(`conffeti_${i}.png`);
        }

        this.bigWinEmitter = this.bigWinParticles.createEmitter({
            frame:  {frames, cycle: true },
            x: { min: 0, max: this.cameras.main.width },
            y: -50,
            lifespan: 5000,
            gravityY: 300,
            quantity: 4,
            angle: { min: 0, max: 360 }, 
            rotate: { start: 0, end: 100 },
            scale: { min: 0.5, max: 1 },
            speedY: { min: 0, max: 200 },
            blendMode: 'ADD'
        });

        this.bigWinPositioner();
        this.bigWinTitle.setScale(0);
        this.bigWinAmountContainer.setScale(0);
        this.tweens.add({
            targets: this.bigWinContainer,
            alpha: 1,
            ease: 'Power0',
            duration: 500,
            onComplete: () => {
                this.bigWinAmountContainer.setScale(1);
                this.bigWinAmountContainer.setY(-(this.bigWinAmountContainer.height / 2) - this.cameras.main.height / 2);

                this.time.delayedCall(150, () => {
                    this.sound.play('sfx_popup-big_win-yeti-voice');
                    this.yetiDown.play('yeti_down');
                });

                this.bigWinSound.play();

                this.bigWinTween = this.tweens.add({
                    targets: this.bigWinAmountContainer,
                    y: this.bigWinAmountContainer.originalY,
                    ease: 'Power0',
                    duration: 250,
                    onComplete: () => {
                        this.bigWinTween = this.tweens.add({
                            targets: [this.bigWinTitle, this.bigWinTitle2],
                            scale: 1,
                            ease: Phaser.Math.Easing.Back.Out,
                            duration: 500,
                            onComplete: () => {
                                this.bigWinContainer.setInteractive({ cursor: 'pointer'})
                                .once('pointerup', () => {
                                    this.destroyBigWin();
                                });

                                this.time.delayedCall(500, () => {
                                    this.bigWinEmitter.stop();
                                })
        
                                this.bigWinTimer = this.time.delayedCall(4000, () => {
                                    this.destroyBigWin();
                                })
                            }
                        });

                    }
                });
            }
        });
    }

    destroyBigWin() {
        if (this.bigWinDestroyed) {
            return;
        }

        this.bigWinDestroyed = true;

        this.customHelper.removeClickable(this.bigWinContainer);
        if(this.bigWinTimer) {
            this.bigWinTimer.remove();
        }
        this.tweens.add({
            targets: [this.bigWinContainer, this.bigWinParticles],
            alpha: 0,
            ease: 'Power0',
            duration: 500,
            onComplete: () => {
                if(this.bigWinTween && this.bigWinTween.isPlaying()) {
                    this.bigWinTween.stop();
                    this.bigWinTween.remove();
                }
        
                if(this.bigWinEmitter) {
                    this.bigWinEmitter.stop();
                }
        
                if(this.bigWinContainer) {
                    this.bigWinContainer.destroy();
                }
        
                if(this.bigWinAmountContainer) {
                    this.bigWinAmountContainer.destroy()
                }
        
                if(this.bigWinParticles) {
                    this.bigWinParticles.destroy()
                }
        
                this.ticketFinished();
                this.fadeInMainFader();

                this.bigWinSound.stop();
            }
        });
    }

    showBonusWin(item) {
        this.bonusWinContainer = this.add.container();
        this.bonusWinContainer.setAlpha(0);

        this.popBg = this.add.sprite(0, 0, 'pop_bg').setOrigin(0.5);
        this.popLights = this.add.sprite(0, 0, 'pop_lights').setOrigin(0.5);
        this.bonusWinImage = this.add.sprite(0, 0, 'bonus_3').setOrigin(0.5, 1).setScale(0).setFrame(0);
        this.bonusWinText = this.add.sprite(0, 0, 'bonus_text').setScale(0);

        this.bonusWinTitle = this.add.text(0, 0, `${Config.lang.bonus_winning}`, this.fonts.yellow_title).setOrigin(0.5, 1).setScale(0); //todo check bonus translate in LT
        this.bonusWinAmountContainer = this.customHelper.createWinningFromSprites(General.format_currency(this.request.scenario.bonus['value']).replace(Config.currency.symbol, ''), 1, '_yellow', -25);
        this.bonusWinContainer.add(this.popBg);
        this.bonusWinContainer.add(this.popLights);
        this.bonusWinContainer.add(this.bonusWinImage);
        this.bonusWinContainer.add(this.bonusWinText);
        this.bonusWinContainer.add(this.bonusWinTitle);
        this.bonusWinContainer.add(this.bonusWinAmountContainer);

        this.bonusWinPositioner();
        this.bonusWinTitle.setScale(0);
        this.bonusWinAmountContainer.setScale(0);
        
        this.tweens.add({
            targets: this.bonusWinContainer,
            alpha: 1,
            ease: 'Power0',
            duration: 500,
            onComplete: () => {
                this.bonusWinSound.play();

                this.bonusWinTween = this.tweens.add({
                    targets: [this.bonusWinTitle, this.bonusWinAmountContainer, this.bonusWinImage, this.bonusWinText],
                    scale: 1,
                    ease: Phaser.Math.Easing.Back.Out,
                    duration: 500,
                    onComplete: () => {
                        this.bonusWinContainer.setInteractive({ cursor: 'pointer'})
                        .once('pointerup', () => {
                            this.destroyBonusWin(item);
                        });

                        this.bonusWinTimer = this.time.delayedCall(3000, () => {
                            this.destroyBonusWin(item);
                        });
                    }
                });
            }
        });
    }

    destroyBonusWin(item) {
        this.customHelper.removeClickable(this.bonusWinContainer);

        if(this.bonusWinTimer) {
            this.bonusWinTimer.remove();
        }

        this.tweens.add({
            targets: this.bonusWinContainer,
            alpha: 0,
            ease: 'Power0',
            duration: 500,
            onComplete: () => {
                if(this.bonusWinTween && this.bonusWinTween.isPlaying()) {
                    this.bonusWinTween.stop();
                    this.bonusWinTween.remove();
                }
                
                if(this.bonusWinContainer) {
                    this.bonusWinContainer.destroy();
                }

                if(this.bonusWinAmountContainer) {
                    this.bonusWinAmountContainer.destroy();
                }

                this.backToMainGame();
                
                this.time.delayedCall(500, () => {
                    item.win_light.destroy();
                    item.frame_anim.destroy();
                })

                this.bonusWinSound.stop();
            }
        });
    }

    regularWinPositioner() {
        if(!this.regularWinContainer) {
            return;
        }

        this.regularWinContainer.x = this.cameras.main.centerX;
        this.regularWinContainer.y = this.cameras.main.centerY;
        this.regularWinContainer.setSize(this.cameras.main.width, this.cameras.main.height);

        this.regularWinTitle.setY(-(this.regularWinTitle.displayHeight) - 5);
        this.regularWinAmountContainer.setY(this.regularWinAmountContainer.displayHeight / 2 + 5);

        if(this.orientationIsSetToPortrait()) {
            this.popBg.setAngle(90);
            this.popLights.setAngle(90);
        } else {
            this.popBg.setAngle(0);
            this.popLights.setAngle(0);
        }
    }

    bigWinPositioner() {
        if(!this.bigWinContainer) {
            return;
        }

        this.bigWinContainer.x = this.cameras.main.centerX;
        this.bigWinContainer.y = this.cameras.main.centerY;

        this.bigWinContainer.setSize(this.cameras.main.width, this.cameras.main.height);

        this.bigWinTitle.setY(-(this.bigWinTitle.height) - 100);
        this.bigWinTitle2.setY(-90);
        this.bigWinAmountContainer.setY(0);
        this.bigWinAmountContainer.originalY = this.bigWinAmountContainer.y;
        this.yetiDown.setY(-130)

        this.bigWinEmitter.setPosition({ min: 0, max: this.cameras.main.width }, -50);

        if(this.orientationIsSetToPortrait()) {
            this.popBg.setAngle(90);
            this.popLights.setAngle(90);
        } else {
            this.popBg.setAngle(0);
            this.popLights.setAngle(0);
        }
    }

    bonusWinPositioner() {
        if(!this.bonusWinContainer) {
            return;
        }
        
        this.bonusWinContainer.setScrollFactor(0,0);
        this.bonusWinContainer.setSize(this.cameras.main.width, this.cameras.main.height);
        this.bonusCamera.setSize(this.cameras.main.width, this.cameras.main.height);
        this.bonusCamera.setLerp(1, 1);
        this.bonusWinContainer.setSize(this.cameras.main.width, this.cameras.main.height);
        this.bonusWinContainer.x = this.cameras.main.centerX;
        this.bonusWinContainer.y = this.cameras.main.centerY;

        this.bonusWinTitle.setY(-(this.bonusWinTitle.displayHeight) - 5);
        this.bonusWinAmountContainer.setY(this.bonusWinAmountContainer.displayHeight / 2 + 5);
        this.bonusWinImage.setY(this.bonusWinTitle.y - this.bonusWinTitle.height - 5);
        this.bonusWinText.setX(this.bonusWinImage.x).setY(this.bonusWinText.y - 155);

        if(this.orientationIsSetToPortrait()) {
            this.popBg.setAngle(90);
            this.popLights.setAngle(90);
        } else {
            this.popBg.setAngle(0);
            this.popLights.setAngle(0);
        }
        
        this.bonusCamera.setLerp(0.1, 0.1);
    }

    backToMainGame() {
        this.bonusFinished = true;
        this.bonusStarted = false;
        this.blackCircle.setAlpha(1);
        this.blackCircle.setY(this.bonusCamera.worldView.centerY);

        this.children.bringToTop(this.blackCircle);
        
        this.sound.play('sfx_transition');

        this.tweens.add({
            targets: this.bonusSound,
            volume: 0,
            duration: 500,
            onComplete: () => {
                this.bonusSound.stop();
            }
        });

        this.mainSound.play();
        this.mainSound2.play();
        
        this.tweens.add({
            targets: [this.mainSound, this.mainSound2, this.owlSound],
            volume: 1,
            duration: 500
        });

        this.tweens.add({
            targets: [this.blackCircle],
            scaleX: 120,
            scaleY: 120,
            duration: 500,
            ease: 'Power0',
            onComplete: () => {
                this.bonusActive = false;
                this.yetiIdle.play('yeti_idle');
                this.snow1.setPosition({ min: 0, max: this.cameras.main.width }, -50);
                this.snow2.setPosition({ min: 0, max: this.cameras.main.width }, -50);

                this.bonusWinningsContainer.destroy(); 
                this.bonusContainer.setAlpha(0);
                this.blackCircle.setY(this.cameras.main.worldView.centerY);
                this.bonusCamera.setAlpha(0);
                this.bonus_flying_tile.setAlpha(0);
                
                this.tweens.add({
                    targets: [this.blackCircle],
                    scaleX: 0,
                    scaleY: 0,
                    duration: 500,
                    ease: 'Power0',
                    onComplete: () => {
                        this.blackCircle.setAlpha(0);
                        this.checkForContinueGame();

                        if(this.openedYourSymbols.length !== 20) {
                            this.shakeUnopenedSymbols();
                        }
                    }
                });
            }
        });
    }

    continueToBonus() {
        this.yetiHitGround();
        this.stopIdleTimer();

        this.yetiIdle.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            this.blackCircle.setX(this.cameras.main.centerX).setY(this.cameras.main.centerY);
    
            this.children.bringToTop(this.blackCircle);
            this.blackCircle.setAlpha(1);
    
            this.tweens.add({
                targets: [this.mainSound, this.mainSound2, this.owlSound],
                volume: 0,
                duration: 500,
                onComplete: () => {
                    this.mainSound.stop();
                    this.mainSound2.stop()
                }
            });
    
            this.bonusSound.play();
    
            this.tweens.add({
                targets: this.bonusSound,
                volume: 1,
                duration: 500
            });

            this.sound.play('sfx_transition');
            this.tweens.add({
                targets: [this.blackCircle],
                scaleX: 120,
                scaleY: 120,
                duration: 500,
                ease: 'Power0',
                onComplete: () => {
                    this.bonusContainer.setAlpha(1); 
                    this.bonusWinningsContainer.setAlpha(1);
                    this.blackCircle.setY(this.bonus_bg.height - this.cameras.main.height / 2);

                    this.bonusActive = true;
    
                    this.time.delayedCall(100, () => {
                        this.snow1.setPosition({ min: 0, max: this.cameras.main.width }, this.bonusCamera.worldView.y - 50);
                        this.snow2.setPosition({ min: 0, max: this.cameras.main.width }, this.bonusCamera.worldView.y - 50);
                    });
                    
                    this.bonusCamera.setLerp(1, 1);
                    this.bonusCamera.setAlpha(1);
                    
                    this.bonus_flying_tile.setAlpha(1);
                    this.bonus_button.setAlpha(1);
                    this.bonus_snow.setAlpha(1);
                    this.yetiHit.setAlpha(1);
                    
                    this.children.bringToTop(this.bonus_flying_tile);
                    this.children.bringToTop(this.bonus_button);
                    this.children.bringToTop(this.bonus_snow);
                    this.children.bringToTop(this.yetiHit);
                    this.children.bringToTop(this.snow1);
                    this.children.bringToTop(this.snow2);
                    this.children.bringToTop(this.snowParticles1);
                    this.children.bringToTop(this.snowParticles2);
                    this.children.bringToTop(this.blackCircle);
    
                    store.commit('hideOpenAllButton');
                    store.commit('showCustomPlayButton', 'icon_hand.svg');
                    
                    this.tweens.add({
                        targets: [this.blackCircle],
                        scaleX: 0,
                        scaleY: 0,
                        duration: 500,
                        ease: 'Power0',
                        onComplete: () => {
                            this.blackCircle.setAlpha(0);
                        }
                    });
                }
            });
        });
    }

    customPlayButtonEvent() {
        this.hitTile();
        store.commit('disableOpenAllButton');
    }

    createBonusGame() {
        this.bonusContainer = this.add.container();
        this.bonusContainer.setAlpha(0);

        this.bonus_bg = this.add.sprite(0, 0, 'bonus_bg').setOrigin(0.5, 1);
        this.bonusContainer.add(this.bonus_bg);
        this.bonus_pole = this.add.sprite(0, 0, 'pole').setOrigin(0.5, 1);
        this.bonusContainer.add(this.bonus_pole);
        //this.bonusContainer.add(this.bonus_flying_tile);
        //this.bonusContainer.add(this.bonus_button);
        //this.bonusContainer.add(this.bonus_snow);

        //this.bonusContainer.add(this.yetiHit);
        this.bonus_flying_tile = this.add.sprite(0, 0, 'flying_tile_animation').setOrigin(0.5, 0.5).setAlpha(0);
        this.bonus_button = this.add.sprite(0, 0, 'button').setOrigin(0.5, 1).setAlpha(0);
        this.bonus_snow = this.add.sprite(0, 0, 'snow').setOrigin(0.5, 1).setAlpha(0);
        this.yetiHit = this.add.sprite(0, 0, 'yeti_hit').setOrigin(0, 1).setAlpha(0);

        let config = this.anims.create({
            key: 'yeti_hit',
            frames: this.anims.generateFrameNames('yeti_hit',
            {
                prefix: 'BHIT',
                start: 1,
                end: 13,
                suffix: '.png' 
            }),
            frameRate: 15
        });

        this.yetiHit.anims.load(config);
        this.yetiHit.setFrame('BHIT1.png');

        config = {
            key: 'flying_tile_animation',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('flying_tile_animation', {
                start: 0,
                end: 5,
            }),
            frameRate: 20,
            repeat: -1
        };

        this.bonus_flying_tile.anims.create(config);

        let graphics = this.add.graphics({ fillStyle: { color: 0x000000 }, add: false});
        let circle = new Phaser.Geom.Circle(25, 18, 12.5);
        graphics.fillCircleShape(circle);
        graphics.generateTexture('blackCircle', 50, 36);

        this.blackCircle = this.add.sprite(0, 0, 'blackCircle').setOrigin(0.5).setScale(0);
        graphics.destroy();
        this.bonusCamera = this.cameras.add(0, 0);
        this.bonusCamera.startFollow(this.bonus_flying_tile, true);
        this.bonusCamera.setAlpha(0);
    }

    createFader() {
        this.fullFaderMain = this.add.graphics().fillStyle(0x000000, 1).fillRect(0, 0, 1920, 1920);
        this.fullFaderMain.setAlpha(0.4);
    }

    fadeInMainFader() {
        this.children.bringToTop(this.fullFaderMain);
        this.tweens.add({
            targets: this.fullFaderMain,
            alpha: 0.4,
            ease: 'Power0',
            duration: 500
        });
    }

    getYForTileToStop() {
        const item = this.bonusWinningsItems[this.request.scenario.bonus['index']];

        let toY = item.y + this.bonusContainer.y + 80;
        
        if(this.orientationIsSetToPortrait()) {
            toY *=  this.bonusContainer.scaleX;
        }

        return toY;
    }

    hitTile() {
        if(this.tileHitRunning) {
            return;
        }

        this.customHelper.removeClickable(this.yetiHit);
        
        store.commit('disableCustomPlayButton');

        this.tileHitRunning = true;

        this.yetiHit.play('yeti_hit');

        this.bonusCamera.setLerp(0.1, 0.1);

        const item = this.bonusWinningsItems[this.request.scenario.bonus['index']];
        let toY = this.getYForTileToStop();

        this.time.delayedCall(400, () => {
            this.sound.play('sfx_bonus_hit');
            this.bonus_button.setTexture('button_push');
            this.bonusCamera.shake(400, 0.01);
            const duration = (this.bonus_flying_tile.y - toY);

            if(duration > 5000) {
                duration = 5000;
            }

            this.beaterRisingSound.setVolume(1);
            this.beaterRisingSound.play();

            this.bonus_flying_tile.tween = this.tweens.add({
                targets: [this.bonus_flying_tile],
                y: toY - (this.orientationIsSetToPortrait() ? 50 : 80),
                duration,
                ease: Phaser.Math.Easing.Sine.Out,
                delay:50,
                onUpdate: () => {
                    this.time.delayedCall(100, () => {
                        this.snow1.setPosition({ min: 0, max: this.cameras.main.width }, this.bonusCamera.worldView.y - 50);
                        this.snow2.setPosition({ min: 0, max: this.cameras.main.width }, this.bonusCamera.worldView.y - 50);
                    });
                },
                onComplete: () => {
                    this.bonus_flying_tile.stop();
                    this.bonus_flying_tile.setFrame(5);
                        this.tweens.add({
                            targets: this.bonusSound,
                            volume: 0,
                            duration: 500,
                            onComplete: () => {
                                if(this.beaterRisingSound.isPlaying) {
                                    this.beaterRisingSound.stop();
                                }
                            }
                        });

                    this.bonus_flying_tile.tween = this.tweens.add({
                        targets: [this.bonus_flying_tile],
                        y: this.getYForTileToStop(),
                        duration: 1000,
                        ease: Phaser.Math.Easing.Sine.Out,
                        onUpdate: () => {
                            this.time.delayedCall(100, () => {
                                this.snow1.setPosition({ min: 0, max: this.cameras.main.width }, this.bonusCamera.worldView.y - 50);
                                this.snow2.setPosition({ min: 0, max: this.cameras.main.width }, this.bonusCamera.worldView.y - 50);
                            });
                        },
                        onComplete: () => {
                            let delay = 1000;

                            if(this.request.scenario.bonus['value'] > 0) {
                                item.win_light.setAlpha(1);
                                item.amount.setAlpha(0);
                                item.amount_won.setAlpha(1);

                                this.request.addAmountWon(this.request.scenario.bonus['value']);
            
                                this.sound.play('sfx_beater_stops-win');

                                this.tweens.add({
                                    targets: [item.win_light],
                                    scaleX: 1,
                                    scaleY: 1,
                                    duration: 1000,
                                    ease: Phaser.Math.Easing.Quartic.Out,
                                });

                                item.frame_anim.setAlpha(1);
                                item.frame_anim.play(item.frame_anim.texture.key);

                                delay = 2000;

                                this.time.delayedCall(delay, () => {
                                    this.showBonusWin(item);
                                });
                            } else {
                                this.time.delayedCall(delay, () => {
                                    this.backToMainGame();
                                });
                            }
                        }
                    });
                }
            });

            this.bonus_flying_tile.play('flying_tile_animation');
        });
    }

    gamePositioner() {
        if(!this.spritesReady) {
            return;
        }

        if(this.alignGrid) {
            this.alignGrid.destroy();
            delete this.alignGrid;
        }
        
        this.alignGrid = new AlignGrid({
            'scene': this,
            'cols': 21,
            'rows': 21
        });
        //this.alignGrid.showNumbers()

        let bonusSeparateItemsOffset = 0;

        if(this.orientationIsSetToPortrait()) {
            this.bonusContainer.setScale(0.5625);
            
            this.bg.setTexture('bg_portrait');
            
            this.alignGrid.placeAtIndex(399, this.tree_left, 20);
            this.alignGrid.placeAtIndex(419, this.tree_right);
            
            this.yetiIdle.setX(this.cameras.main.centerX).setY(this.cameras.main.height - 110);

            this.alignGrid.placeAtIndex(0, this.logo);
            this.alignGrid.placeAtIndex(83, this.bonus_marker);

            this.mainGameGroup
                .setX(this.cameras.main.centerX - 125)
                .setY(this.logo.y + this.logo.height + 40);
            
            this.shadow.setX(this.cameras.main.centerX + 25).setY(this.cameras.main.centerY - 150);

            this.snow1.setLifespan(24000); 
            this.snow2.setLifespan(24000); 
            bonusSeparateItemsOffset = (this.bonus_bg.height * this.bonusContainer.scaleX - this.bonus_bg.height);
        } else {
            this.bonusContainer.setScale(1);
            this.bg.setTexture('bg');

            this.alignGrid.placeAtIndex(336, this.tree_left, 20);
            this.alignGrid.placeAtIndex(377, this.tree_right);

            this.alignGrid.placeAtIndex(359, this.yetiIdle, 20);

            this.alignGrid.placeAtIndex(0, this.logo, 20);
            this.alignGrid.placeAtIndex(125, this.bonus_marker, 20);

            this.mainGameGroup
                .setX(this.cameras.main.centerX)
                .setY(0);

            this.snow1.setLifespan(12000); 
            this.snow2.setLifespan(12000);

            this.shadow.setX(this.cameras.main.centerX + 150).setY(this.cameras.main.centerY);
        }

        this.bonusText.setX(this.bonus_marker.x - this.bonus_marker.width / 2).setY(this.bonus_marker.y - 80);

        const bonusBgDisplayWidth = this.bonus_bg.displayWidth * this.bonusContainer.scaleX;
        const bonusBgDisplayHeight = this.bonus_bg.displayHeight * this.bonusContainer.scaleY;

        this.bonusContainer.x = this.cameras.main.centerX;
        this.bonusContainer.y = 0;

        if(this.bonusWinningsContainer) {
            this.bonusWinningsContainer.setScale(this.bonusContainer.scaleX);
            this.bonusWinningsContainer.setX(this.bonusContainer.x).setY(this.bonusContainer.y);
        }
        
        this.yetiIdleSpeech.setX(this.yetiIdle.x + 70).setY(this.yetiIdle.y-this.yetiIdle.height - 10);
        this.yetiIdleSpeechText.setX(this.yetiIdleSpeech.x + this.yetiIdleSpeech.width / 2).setY(this.yetiIdleSpeech.y - 15);

        this.bonus_bg.setX(0).setY(this.bonus_bg.displayHeight);
        this.bonus_pole.setX(0).setY(this.bonus_bg.displayHeight - 200);
        this.bonus_flying_tile.setScale(this.bonusContainer.scaleX);

        this.positionTile();

        if(this.tileHitRunning) {
            if(this.bonus_flying_tile.tween && this.bonus_flying_tile.tween.isPlaying()) {
                this.bonus_flying_tile.tween.complete();
            }

            this.bonus_flying_tile.setY(this.getYForTileToStop());
        }

        this.bonus_button.setScale(this.bonusContainer.scaleX);
        this.bonus_snow.setX(this.bonusContainer.x).setScale(this.bonusContainer.scaleX);
        this.yetiHit.setScale(this.bonusContainer.scaleX);
        
        this.bonus_button
            .setScale(this.bonusContainer.scaleX)
            .setX(this.bonusContainer.x)
            .setY(this.bonus_pole.y + 170 + bonusSeparateItemsOffset);

        this.bonus_snow
            .setScale(this.bonusContainer.scaleX)
            .setX(this.bonusContainer.x)
            .setY(this.bonus_bg.displayHeight - 40 + bonusSeparateItemsOffset);

        this.yetiHit
            .setScale(this.bonusContainer.scaleX)
            .setX(this.bonus_button.x - this.bonus_button.displayWidth - 330 * this.bonusContainer.scaleX)
            .setY(this.bonus_pole.y + bonusSeparateItemsOffset + (this.orientationIsSetToPortrait() ? 100 : 30));

        let startX = -180;
        let startY = 440;
        let snowballOfssetX = 30;
        let snowballOfssetY = 25;
        
        this.mainGameGroup.setChildLocalPosition(this.luckyNumberRibbon, 130, 70);
        this.mainGameGroup.setChildLocalPosition(this.luckyNumbersHolder, this.luckyNumberRibbon.rexContainer.x, 250);
        this.mainGameGroup.setChildLocalPosition(this.yourNumberRibbon, this.luckyNumberRibbon.rexContainer.x, 325);
        
        this.mainGameGroup.setChildLocalPosition(this.luckyNumberRibbonText, this.luckyNumberRibbon.rexContainer.x, this.luckyNumberRibbon.rexContainer.y-10);
        this.mainGameGroup.setChildLocalPosition(this.yourNumberRibbonText, this.yourNumberRibbon.rexContainer.x, this.yourNumberRibbon.rexContainer.y-10);

        for(let i = 0; i < 4; i++) {
            let item = this.mainGameItems['lucky_symbols'][i];
            let x = (this.luckyNumbersHolder.rexContainer.x - this.luckyNumbersHolder.displayWidth / 2) + i * (item.displayWidth + snowballOfssetX) + 100;

            if(item.dropTween && item.dropTween.isPlaying()) {
                item.dropTween.stop();
            }

            this.mainGameGroup.setChildLocalPosition(item, x, this.luckyNumbersHolder.rexContainer.y - this.luckyNumbersHolder.displayHeight / 2 - 20);
            this.mainGameGroup.setChildLocalPosition(item.exploder, item.rexContainer.x, item.rexContainer.y);
            this.mainGameGroup.setChildLocalPosition(item.number, item.rexContainer.x, item.rexContainer.y);

            item.originalX = item.x;
            item.originalY = item.y;
        }

        for(let i = 0; i < 20; i++) {
            let item = this.mainGameItems['your_symbols'][i];
            
            if(item.dropTween && item.dropTween.isPlaying()) {
                item.dropTween.stop();
            }

            this.mainGameGroup.setChildLocalPosition(item, startX, startY);
            this.mainGameGroup.setChildLocalPosition(item.holder, startX, startY + 9);
            this.mainGameGroup.setChildLocalPosition(item.exploder, item.rexContainer.x, item.rexContainer.y + 8);

            this.mainGameGroup.setChildLocalPosition(item.number, startX, startY);
            this.mainGameGroup.setChildLocalPosition(item.win_light, startX, startY);
            this.mainGameGroup.setChildLocalPosition(item.win_placeholder, startX, startY + 50);
            this.mainGameGroup.setChildLocalPosition(item.win, item.win_placeholder.rexContainer.x, item.win_placeholder.rexContainer.y);

            startX += item.displayWidth + snowballOfssetX;

            if([4, 10, 15].includes(i)) {
                startY += item.displayHeight + snowballOfssetY;

                startX = -180;

                if(i == 4) {
                    startX = startX -((item.displayHeight + snowballOfssetX) / 2);
                } 

                if(i == 15) {
                    startX = startX + (item.displayHeight + snowballOfssetX) / 2;
                }
            }

            item.originalX = item.x;
            item.originalY = item.y;
        }

        this.blackCircle.setX(this.cameras.main.centerX).setY(this.cameras.main.centerY);

        this.bonusCamera.setBounds(0, 0, bonusBgDisplayWidth, bonusBgDisplayHeight);

        this.time.delayedCall(100, () => {
            if(this.bonusActive) {
                this.snow1.setPosition({ min: 0, max: this.cameras.main.width }, this.bonusCamera.worldView.y - 50);
                this.snow2.setPosition({ min: 0, max: this.cameras.main.width }, this.bonusCamera.worldView.y - 50);
            } else {
                this.snow1.setPosition({ min: 0, max: this.cameras.main.width }, -50);
                this.snow2.setPosition({ min: 0, max: this.cameras.main.width }, -50);
            }
        });

        this.regularWinPositioner();
        this.bonusWinPositioner();
        this.bigWinPositioner();
    }

    positionTile() {
        let tileOffset = 115;

        if(!this.bonusStarted || ! this.bonus_flying_tile.tween || (this.bonus_flying_tile.tween && !this.bonus_flying_tile.tween.isPlaying())) {
            let bonusSeparateItemsOffset = 0;

            if(this.orientationIsSetToPortrait()) {
                bonusSeparateItemsOffset = (this.bonus_bg.height * this.bonusContainer.scaleX - this.bonus_bg.height);
                tileOffset = -10;
            }

            this.bonus_flying_tile.setY(this.bonus_pole.y - tileOffset + bonusSeparateItemsOffset);
        }

        this.bonus_flying_tile.setX(this.bonusContainer.x);
    }

    properties() {
        this.fonts = {
            normalWhite: {
                fontFamily: 'russoone',
                fontSize: '22px',
                fontStyle: 'normal',
                color: '#FFFFFF',
                stroke: '#000000',
                strokeThickness: 3,
                align: 'center'
            },
            winBlue: {
                fontFamily: 'russoone',
                fontSize: '26px',
                fontStyle: 'normal',
                color: '#226c88',
                align: 'center'
            },
            winRed: {
                fontFamily: 'russoone',
                fontSize: '26px',
                fontStyle: 'normal',
                color: '#ac2532',
                align: 'center'
            }, 
            white_title: {
                fontFamily: 'russoone',
                fontSize: '90px',
                fontStyle: 'normal',
                color: '#FFFFFF',
                stroke: '#000000',
                strokeThickness: 5,
                align: 'center',
                shadow: { stroke: true, blur: 12, fill: true, color: '#FFFFFF' },
                padding: { top: 5, bottom: 5, left: 5, right: 5 }
            },
            yellow_title: {
                fontFamily: 'russoone',
                fontSize: '60px',
                fontStyle: 'normal',
                color: '#eeba0d',
                stroke: '#000000',
                strokeThickness: 3,
                align: 'center',
            },
            white_title_big: {
                fontFamily: 'russoone',
                fontSize: '130px',
                fontStyle: 'normal',
                color: '#FFFFFF',
                stroke: '#000000',
                strokeThickness: 7,
                align: 'center',
                shadow: { stroke: true, blur: 12, fill: true, color: '#FFFFFF' },
                padding: { top: 5, bottom: 5, left: 5, right: 5 }
            },
            yeti_speech_text: {
                fontFamily: 'russoone',
                fontSize: '24px',
                color: '#000000',
                align: 'center',
                wordWrap: { width: 300 },
                lineSpacing: 7
            },
        }
    }
}

startGame(GameScene);